import axios from "../../../axios";

const removeSubcategoryFromArea = (area, subcategoryId) => {
  area.rootcausecategories = area.rootcausecategories.map((item) => {
    item.rootcausesubcategories = item.rootcausesubcategories.filter((subcategory) => {
      return subcategory.id !== subcategoryId;
    });
    return item;
  });
  return area;
};

const removeEmptyCategoriesFromArea = (area, categoryId) => {
  area.rootcausecategories = area.rootcausecategories.filter((item) => {
    return item.id !== categoryId || item.rootcausesubcategories.length > 0;
  });
  return area;
};

export const getCriteriaData = (data) => {
  return axios.get("qam/criterias", {
    params: {
      "field": ["audit_id", "classification_option_id", "corrective_action_id"],
      "op": ["eq", "eq", "eq"],
      "term": [data.audit_id, data.classification_option_id, data.id],
      "with": ["evidences"]
    }
  });
};

export const prepareRootCausesOptions = (existentRootCausesArg, areasDataArg, dataId) => {
  const existentRootCauses = existentRootCausesArg || [];
  const areasData = areasDataArg || [];
  let areas = [...areasData];
  if (existentRootCauses.length > 0) {
    existentRootCauses
      .filter((item) => item.id !== dataId)
      .forEach((alreadyHave) => {
        areas = areas.map((a) => removeSubcategoryFromArea(a, alreadyHave.root_cause_subcategory_id));
        areas = areas.map((a) => removeEmptyCategoriesFromArea(a, alreadyHave.root_cause_category_id));
        areas = areas.filter((item) => item.rootcausecategories.length > 0);
      });
  }
  return areas;
};

export const getSelectedClassificationOption = (classificationOptions, classificationOptionId) => {
  if (!classificationOptions || !classificationOptionId) {
    return null;
  }

  return classificationOptions.find((option) => option.id === classificationOptionId);
};
